import MoreIcon from '@mui/icons-material/MoreVert'
import { GridActionsCellItem } from '@mui/x-data-grid-pro'
import React, { useCallback } from 'react'

import { useCatalog } from '../hooks/useCatalog'
import { MenuDialog } from '../MenuDialog'

type Props = {
  catalog: ReturnType<typeof useCatalog>
  params: any
}

export const EditButton = (props: Props) => {
  const { catalog, params } = props

  const [anchor, setAnchor] = React.useState<null | HTMLElement>(null)

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => setAnchor(e.currentTarget),
    [],
  )

  const dismiss = useCallback(() => setAnchor(null), [])

  const handleDelete = useCallback(() => {
    catalog.openDeleteDialog(params.id)
    dismiss()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleEdit = useCallback(() => {
    catalog.openEditDialog(params.id)
    dismiss()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <GridActionsCellItem
        data-test-id="catalog-row-actions-button"
        icon={<MoreIcon />}
        label="More"
        onClick={handleClick}
      />
      <MenuDialog anchorElement={anchor} dismiss={dismiss} handleDelete={handleDelete} handleEdit={handleEdit} />
    </>
  )
}
